// Vista previa del correo tal como lo arma el servidor (iframe aislado).
import React, { useState } from 'react';
import { Modal, Segmented } from 'antd';
import { DesktopOutlined, MobileOutlined } from '@ant-design/icons';

export default function VistaPreviaCorreo({ abierta, onCerrar, asunto, html }) {
  const [ancho, setAncho] = useState('escritorio');
  return (
    <Modal open={abierta} onCancel={onCerrar} footer={null} width={720} title={asunto || 'Vista previa'} destroyOnHidden>
      <div className="flex justify-center mb-3">
        <Segmented
          value={ancho}
          onChange={setAncho}
          options={[
            { value: 'escritorio', label: 'Escritorio', icon: <DesktopOutlined /> },
            { value: 'telefono', label: 'Teléfono', icon: <MobileOutlined /> },
          ]}
        />
      </div>
      <div className="flex justify-center bg-gray-100 rounded-lg p-2">
        {/* sandbox vacío: sin scripts ni navegación desde el correo */}
        <iframe
          title="Vista previa del correo"
          sandbox=""
          srcDoc={html}
          style={{ width: ancho === 'telefono' ? 360 : 640, height: 600, border: 0, background: '#fff', borderRadius: 8 }}
        />
      </div>
    </Modal>
  );
}
